import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConnectedApp } from './app';
import './ui/index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ConnectedApp />
  </React.StrictMode>,
);
